<template>
  <div class="border-b p-2 border-gray-300 hover:bg-indigo-100 relative" :class="{'bg-indigo-100': isCurrent}">
    <VLink v-bind:href="conversationUrl" class="conversation-list-item-grid">
      <Avatar v-bind:customer="conversation.customer.attributes" />
      <div v-bind:class="{ 'text-pink-700': isCreated }">
        <p>
          <span v-if="conversation.customer.attributes.name" class="text-sm" v-bind:class="{ 'font-bold': hasUnread, 'font-medium': !hasUnread }">
            {{conversation.customer.attributes.name}}
          </span>
          <span class="float-right text-gray-500 text-right text-xs">
            <Datetime v-bind:date="conversation.last_updated_at" fromNow="true" /><br>
          </span>
        </p>
        <blockquote class="truncate text-gray-500 text-xs max-w-xs">
          <span class="">{{showcasedMessage.text}}</span>
          <Counter v-if="hasUnread" v-bind:count="conversation.customer_messages_unread_count" inline="true" position="absolute bottom-5 right-2" />
        </blockquote>
      </div>
    </VLink>
  </div>
</template>


<script>
import VLink from '../page/VLink.vue'
import Avatar from './parts/AvatarWidget.vue'
import Counter from '../page/CounterWidget.vue'
import Datetime from '../building_blocks/DateTime.vue'

export default {
  name: 'ConversationListItem',
  props: ['conversation', 'conversationSelected', 'showUnreadCounter'],
  components: {
    VLink,
    Avatar,
    Counter,
    Datetime,
  },
  computed: {
    hasUnread() {
      return this.unreadCount > 0 && this.showUnreadCounter;
    },
    conversationUrl() {
      return `/conversations/${this.conversation.id}`;
    },
    showcasedMessage() {
      if(this.conversation.latest_message.type === 'internal_message') {
        return this.conversation.latest_customer_message;
      }
      return this.conversation.latest_message;
    },
    isCreated() {
      return this.conversation.status === 'created';
    },
    isCurrent() {
      return this.conversation.id === this.conversationSelected;
    },
    unreadCount() {
      return this.conversation.customer_messages_unread_count;
    },
  },
}
</script>
